import storage from 'redux-persist/lib/storage';

const persistConfig = {
    key: 'root',
    storage,  
};

export default persistConfig;
